/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { Field, reduxForm } from 'redux-form';
import { FormFieldsComposer } from 'common/dynamics';

import { DefaultButton, CheckboxField, BasicModal } from 'common/components';

import { FormattedMessage } from 'react-intl';

import { finishPayment, getConfirmationForm } from '../../_redux';

import { staticStyles } from './style';

const SecondPaymentsForm = ({
  initialize,
  paymentForm,
  onResetForm,
  isModal,
  isNullForm,
  justFinish,
  handleSubmit,
  invalid,
  dispatch,
  submitting,
  isAllFieldsRequired,
  openConfirmationModal,
}) => {
  const [isSaveRequisites, setSaveRequisites] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  const { properties } = paymentForm.requisitesForm?.form || [];
  const formInitialValues = paymentForm.requisitesForm?.value || null;

  const cancelTitle = isModal ? 'justCancel' : 'justReset';

  useEffect(() => {
    if (formInitialValues && Object.keys(formInitialValues).length > 0) {
      initialize(formInitialValues);
    }
  }, []);

  const extraFields = justFinish
    ? []
    : Object.keys(properties).map(name => (
        <FormFieldsComposer
          key={name}
          name={name}
          schema={properties[name]}
          formName="payments-second-form"
          submitting={submitting}
          withoutHeaderDescription
          isAllFieldsRequired={isAllFieldsRequired}
        />
      ));

  const submit = handleSubmit(values => {
    const requisitesForm = isNullForm ? undefined : { ...values, saveRequisites: undefined };
    const saveRequisites = isSaveRequisites;
    let isOnlyRequisites = false;
    // если форма с additional fields и 2fa
    if (paymentForm?.request.status === 'waiting_verification' && !isNullForm) {
      isOnlyRequisites = true;
      setModalOpen(true);
    }

    if (justFinish) {
      return finishPayment(
        {
          ...paymentForm,
          saveRequisites,
        },
        dispatch
      );
    }

    return getConfirmationForm(
      {
        ...paymentForm,
        requisitesForm,
        saveRequisites,
        isOnlyRequisites,
      },
      dispatch
    );
  });

  return (
    <div className="SecondPaymentsForm">
      {!isNullForm && !isModal && (
        <div className="SecondPaymentsForm__header">
          <FormattedMessage id="justStep">
            {txt => <div className="SecondPaymentsForm__step">{`${txt} 2`}</div>}
          </FormattedMessage>
        </div>
      )}
      <div className="SecondPaymentsForm__content">{extraFields}</div>
      {!isNullForm && (
        <Field
          component={CheckboxField}
          name="saveRequisites"
          textId="justSaveMyDetails"
          onChange={e => setSaveRequisites(e.target.checked)}
          disabled={submitting}
          simple
        />
      )}
      <div className="SecondPaymentsForm__btns">
        <DefaultButton
          type="submit"
          textId="justConfirm"
          disabled={invalid || submitting}
          loading={submitting}
          onClick={submit}
          filled
        />
        <DefaultButton type="button" textId={cancelTitle} disabled={submitting} onClick={() => onResetForm()} />
      </div>

      <BasicModal
        captionId="justConfirmationMessageSent"
        isOpen={modalOpen}
        onRequestClose={() => setModalOpen(false)}
      />
      <style jsx>{staticStyles}</style>
    </div>
  );
};

SecondPaymentsForm.propTypes = {
  initialize: PropTypes.func.isRequired,
  paymentForm: PropTypes.object.isRequired,
  isNullForm: PropTypes.bool.isRequired,
  onResetForm: PropTypes.func.isRequired,
  justFinish: PropTypes.bool,
  handleSubmit: PropTypes.func.isRequired,
  isModal: PropTypes.bool,
  dispatch: PropTypes.func.isRequired,
  invalid: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  isAllFieldsRequired: PropTypes.bool,
  openConfirmationModal: PropTypes.func,
};

SecondPaymentsForm.defaultProps = {
  isModal: false,
  justFinish: false,
  isAllFieldsRequired: true,
  openConfirmationModal: null,
};

export default compose(
  reduxForm({
    form: 'payments-second-form',
    onSubmitSuccess: (result, dispatch, { addons, history, closeModal, paymentForm, openConfirmationModal }) => {
      const properties = paymentForm?.requisitesForm?.form ?? {};
      const isNullForm = Object.keys(properties).length ? properties.widget === 'nullform' : true;
      if (result?.confirmationForm && openConfirmationModal) {
        openConfirmationModal(result.values);
      } else if (closeModal) {
        closeModal();
      } else {
        const forward = () => {
          if (paymentForm?.request.status === 'waiting_verification' && !isNullForm) {
            setTimeout(() => {
              history.push(
                addons.includes('wallet')
                  ? `/wallet/dw/${result.values.request.id}`
                  : `/payments/dw/${result.values.request.id}`
              );
            }, 3000);
          } else {
            history.push(
              addons.includes('wallet')
                ? `/wallet/dw/${result.values.request.id}`
                : `/payments/dw/${result.values.request.id}`
            );
          }
        };
        forward();
      }
    },
  })
)(SecondPaymentsForm);
export { SecondPaymentsForm };
